const AppraisalList = [
    {
        empid: "SB001",
        firstname: "Adebisi",
        lastname: "Adetugbo",
        designation: "Software Engineer",
        department: "IT/Techical",
        status: 1
    },
    {
        empid: "SB002",
        firstname: "Wade",
        lastname: "James",
        designation: "Account Officer",
        department: "Sales Executive",
        status: 0
    },
    {
        empid: "SB003",
        firstname: "Collins",
        lastname: "Mayer",
        designation: "Account Officer",
        department: "Sales Executive",
        status: 1
    },
    {
        empid: "SB004",
        firstname: "Brymes",
        lastname: "Lilly",
        designation: "Tech. Support",
        department: "IT/Technical",
        status: 0
    },
    {
        empid: "SB005",
        firstname: "Adebisi",
        lastname: "Adetugbo",
        designation: "Software Engineer",
        department: "IT/Techical",
        status: 1
    },
    {
        empid: "SB006",
        firstname: "Wade",
        lastname: "James",
        designation: "Account Officer",
        department: "Sales Executive",
        status: 0
    },
    {
        empid: "SB007",
        firstname: "Collins",
        lastname: "Mayer",
        designation: "Account Officer",
        department: "Sales Executive",
        status: 1
    },
    {
        empid: "SB008",
        firstname: "Brymes",
        lastname: "Lilly",
        designation: "Tech. Support",
        department: "IT/Technical",
        status: 0
    }
]

export default AppraisalList